import Component from './component.vue';
import { NamePositions, Props as _Props, SlotNames } from './types';

type Props = _Props;

export { NamePositions, Props, SlotNames };
export default Component;



// WEBPACK FOOTER //
// ./src/components/page/organization/index.ts